import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { DiscoveryConnectPage } from "@/features/discovery";

export const Route = createFileRoute("/discovery/connect")({
  component: () => (
    <PermissionGuard module="discovery">
      <DiscoveryConnectPage />
    </PermissionGuard>
  ),
});
